import React from 'react'
import { Form, Field, reduxForm } from 'redux-form'
import RenderFormField from 'components/render-form-field'
import { requiredField, validEmail } from 'util/field-validation'
import striptags from 'striptags'

import CancelableSumbitButton from 'components/buttons/cancelable-submit-button'

const RecoverUsernameForm = ({ submitting, loading, error, handleSubmit }) => {
  const buttonsDisabled = submitting || loading

  const formError = error ? (
    <div
      className='form--error'
      data-ext='form--error-recover-username'
      dangerouslySetInnerHTML={{ __html: striptags(error, ['a']) }}
    />
  ) : null

  return (
    <Form
      id='ext--recover-username-form'
      data-test-key='recover-username-form'
      className='form'
      method='POST'
      noValidate='novalidate'
      onSubmit={handleSubmit}
    >
      <Field
        name='email'
        placeholder='Email address'
        component={RenderFormField}
        type='email'
        validate={[requiredField, validEmail]}
      />

      {formError}

      <CancelableSumbitButton
        testKey='recover-username'
        loading={buttonsDisabled}
        submitText='Recover'
        disabled={buttonsDisabled}
      />
    </Form>
  )
}

export default reduxForm({
  form: 'recoverUsername',
  destroyOnUnmount: true,
})(RecoverUsernameForm)
